import React, { useEffect, useState, Fragment } from 'react';
import { Form, Input, Space } from 'antd';
import '../SurveyAnswer.less';

interface ItemProps {
    text?: string;
    input: boolean;
    len: number;
}

// 填空题
const Fill: React.FC = ({ body, id, required, num, questionTypeId, form, notValitator }: { body?: string; required?: boolean; num?: number; id?: number; questionTypeId?: number; form?: any; notValitator?: any }) => {
    const [data, setData] = useState([]);
    const [title, setTitle] = useState(null);
    const [isShowTip, setIsShowTip] = useState(false);

    const getIsInput = (value: []) => {
        if (value && value.length && required) {
            let isInput = value.filter((it: any) => !it);
            if (isInput && isInput.length) {
                setIsShowTip(true);
            } else {
                setIsShowTip(false);
            }
        } else if (value && value.length && !required) {
            let isInput = value.filter((it: any) => !it);
            let isExistInput = value.filter((it: any) => it);
            if (isExistInput && isExistInput.length && isInput && isInput.length) {
                setIsShowTip(true);
            } else {
                setIsShowTip(false);
            }
        } else {
            setIsShowTip(false);
        }
    };

    // 问卷回显缓存
    useEffect(() => {
        let formData = localStorage.getItem('initFormData');
        if (formData && questionTypeId === 5 && title) {
            let val = JSON.parse(formData)[`${id}-5`];
            if (val && val.length) {
                let inputEle: any = document.querySelectorAll(`.multipleFill${id}`);
                if (inputEle.length) {
                    inputEle.forEach((el: any, index: number) => {
                        el.value = val[index];
                    });
                }
            }
        }
    }, [title, questionTypeId]);

    useEffect(() => {
        if (body) {
            let bodyResult: any = body.replace(/_+/g, `<input class="multipleFill multipleFill${id}" autoComplete="off" value="" maxLength=200 />`);
            setTitle(bodyResult);
        }
    }, [body]);

    // 动态监听多项填空输入值更新
    useEffect(() => {
        if (title && questionTypeId === 5 && form) {
            let inputEle: any = document.querySelectorAll(`.multipleFill${id}`);
            let array = new Array(inputEle.length).fill(undefined);
            inputEle.forEach((element: any, index: number) => {
                element.oninput = function (e: any) {
                    let currentForm = form?.getFieldValue(`${id}-5`) || array;
                    currentForm[index] = e.target.value || null;
                    form.setFieldValue(`${id}-5`, currentForm);
                    localStorage.setItem('formData', JSON.stringify(form.getFieldsValue()));

                    // 多选填空 - 特殊处理，输入实时同步init
                    const initLocal = localStorage.getItem('initFormData');
                    if (initLocal) {
                        let oldVal = JSON.parse(initLocal);
                        oldVal[`${id}-5`] = currentForm;
                        localStorage.setItem('initFormData', JSON.stringify(oldVal));
                    }

                    getIsInput(currentForm);
                };
            });
        }
    }, [title, questionTypeId]);

    // 提交校验是否必填
    useEffect(() => {
        if (notValitator?.indexOf(id) !== -1) {
            setIsShowTip(true);
        } else {
            setIsShowTip(false);
        }
    }, [notValitator]);

    return (
        <>
            {questionTypeId === 5 ? (
                <Form.Item
                    name={[`${id}-5`]}
                    rules={[{ required, message: '' }]}
                    // label={num + '.'}
                    className={`multiple-fill ${isShowTip ? 'ant-form-item-has-error' : null}`}
                >
                    <div className="fill-topic">{<div className="label-flex" style={{ display: 'flex' }} dangerouslySetInnerHTML={{ __html: `<span class="title-num ${required ? 'show-required' : null}">${num}.</span><div>${title}</div>` }}></div>}</div>
                    {isShowTip ? <p style={{ color: '#ff4d4f', fontSize: '14px', fontWeight: '400' }}>{required ? '该题为必答题，请作答后提交。' : '请填写完成'}</p> : null}
                </Form.Item>
            ) : (
                <Form.Item name={[`${id}-4`, 0]} rules={[{ required, message: '该题为必答题，请作答后提交。' }]} label={<div className="label-flex" style={{ display: 'flex' }} dangerouslySetInnerHTML={{ __html: `<span class="title-num">${num}.</span>` + `<span>${body}</span>` }}></div>}>
                    <Input maxLength={200} />
                </Form.Item>
            )}
        </>
    );
};

export default Fill;
